import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { SuccessDialogQuizComponent } from '../success-dialog-quiz/success-dialog-quiz.component';

@Injectable({
  providedIn: 'root'
})
export class SuccessDialogQuizService {

  constructor(public dialog: MatDialog) { }

  // learningQuizCode=1 for Basics of Patents Quiz

  // learningQuizCode=2 for Patent Search Quiz

  // learningQuizCode=3 for Patent Draft Quiz

   // ===== Success Dialog =====
   successDialogForQuiz(learningQuizCode,testScore): void {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    if(learningQuizCode == 1){
      dialogConfig.data = {
        title: 'Basics of Patents Quiz',
        routerLink:'/main/learning/learnPatentDrawing',
        testScore:testScore
      };  
      
    }
    if(learningQuizCode == 2){
      dialogConfig.data = {
        title: 'Patent Search Quiz',
        routerLink: '/main/learning/learnPatentDraft',
        testScore:testScore
  };  
    }
    if(learningQuizCode == 3){
      dialogConfig.data = {
        title: 'Patent Draft Quiz',
        routerLink: '/main/learning/learnPatentFiling',
        testScore:testScore

      };  
    }
    
    const dialogRef = this.dialog.open(SuccessDialogQuizComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
      // console.log(result);

    });
  }
}
